import { create } from 'zustand'
import { persist, devtools } from 'zustand/middleware'
import { stopAllSounds } from '../utils/sound'

const useSoundStore = create(
	persist(
		devtools((set, get) => ({
			isEnabled: true,
			toggle: () => set(state => {
				const next = !state.isEnabled
				if (!next) stopAllSounds()
				return { isEnabled: next }
			}),
			setEnabled: (value) => set({ isEnabled: !!value })
		})),
		{ name: 'SoundStore' }
	)
)

export default useSoundStore


